import PropTypes from "prop-types";

import Typography from "@mui/material/Typography";

const Heading = props => {
  const { label, sx, ...others } = props;

  return (
    <Typography align="center" variant="h6" {...others} sx={{ textTransform: "uppercase", p: 1, ...sx }}>
      {label}
    </Typography>
  );
};

Heading.defaultProps = {
  label: "Label",
  sx: null
};

Heading.propTypes = {
  label: PropTypes.string,
  sx: PropTypes.object
};

export default Heading;
